import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { useQuery } from "@apollo/client";
import { TARIFFS_FOR_CATALOG_V3, TARIFFS_FOR_STREET, TARIFFS_FOR_DISTRICT } from "Services/queries";
import { sendMetriks } from "Services/sendMetriks";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import Metrika from "Services/Metrika";
import { isMoscowSiteCode, isMainSiteCode, isPiterSiteCode } from "Utils/siteConfig";
import { pipe } from "Utils/functionalUtils";
import Routes from "Configs/routes";
import ProviderConnectHOC from "HOC/ProviderConnectHOC";
import { TariffsLayout as MicroMarkupTariffsLayout } from "Layouts/MicroMarkup";
import ProviderUpdatedItemContainer from "Containers/ProviderUpdatedItemContainer";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import { Col } from "ComponentsUI/Styles/Grid";
import Button from "ComponentsUI/Button";
import OneClick from "Containers/OneClick";

const useStyles = createUseStyles((theme) => ({
	root: {},
	wrapper: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		flexWrap: "wrap",
	},
	blocksWrapper: {
		marginBottom: "20px",
		width: "101%",
		borderRadius: "10px",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	noFlatWrapper: {
		marginRight: "-10px",
		marginLeft: "-10px",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		noFlatWrapper: {
			marginRight: "-5px",
			marginLeft: "-5px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		noFlatWrapper: {
			marginRight: "0",
			marginLeft: 0,
		},
		blocksWrapper: {
			marginBottom: "0",
		},
	},
}));

const ListOfProvidersWithInjectedTariffs = (props) => {
	let classes = useStyles();
	let connectTariffButton =
		props.ApplicationModel?.siteConfig?.settings?.connect_tariff_button?.catalog_prov || "connect";
	let items = props.items;
	let providerIDs = [];
	items.map((item) => {
		providerIDs.push(item.id);
	});

	const { data: dataCatalog } = useQuery(TARIFFS_FOR_CATALOG_V3, {
		skip: props.pageName !== "catalog_prov",
		variables: {
			providerIDs: providerIDs,
			limitByProvider: 2,
			providerJoin: true,
		},
	});

	const { data: dataStreet } = useQuery(TARIFFS_FOR_STREET, {
		skip: props.pageName !== "street_prov",
		variables: {
			providerIDs: providerIDs,
			limitByProvider: 2,
			providerJoin: true,
		},
	});
	const { data: dataDistrict } = useQuery(TARIFFS_FOR_DISTRICT, {
		skip: props.pageName !== "district_prov" || !props.districtsOne,
		variables: {
			districtId: props.districtsOne?.id,
			providerIDs: providerIDs,
			limitByProvider: 2,
			providerJoin: true,
		},
	});

	let tariffs =
		dataCatalog?.tariffsForCatalogV3?.data ||
		dataStreet?.tariffsForStreet?.data ||
		dataDistrict?.tariffsForDistrict?.data ||
		[];

	const sendYandexMetrika = () => {
		try {
			Metrika.getInstance().yandex.sendEvent(props.yandexEvent, {
				params: { providers_count_view: props.items.length },
			});
		} catch (e) {
			console.warn("Error sendMetrica", e);
		}
	};

	const generateProviders = () => {
		let text = props.ApplicationModel.text;
		let items = props.items;
		let providerModel = props.ApplicationModel.providerModel;

		if (!windowSize.xs && !props.flat) {
			let blocks = [];
			let adElem = [<OneClick key="adblock2" />];
			items.map((item, index) => {
				if (!item?.sell_self?.provider?.name) {
					blocks.push(
						<ProviderConnectHOC key={"i" + index} callbackFn={() => props.onProviderConnect(item)}>
							<ProviderUpdatedItemContainer
								text={text}
								onProviderSelect={() => props.onProviderSelect(item)}
								onProviderRates={() => props.onProviderRates(item)}
								onProviderReviews={() => props.onProviderReviews(item)}
								data={item}
								windowSize={windowSize}
								flat={props.flat}
								ratesView={props.ratesView}
								tariffs={tariffs}
								hideProviderLogo={props.hideProviderLogo}
								providerModel={providerModel}
								isProviderCatalog={true}
								pageName={props.pageName}
							/>
						</ProviderConnectHOC>
					);
				} else {
					blocks.push(
						<ProviderConnectHOC key={"i" + index} callbackFn={() => props.onProviderConnect(item)}>
							<ProviderUpdatedItemContainer
								selled={true}
								text={text}
								onProviderSelect={() => props.onProviderSelect(item)}
								onProviderRates={() => props.onProviderRates(item)}
								onProviderReviews={() => props.onProviderReviews(item)}
								data={item}
								windowSize={windowSize}
								flat={props.flat}
								ratesView={props.ratesView}
								tariffs={tariffs}
								hideProviderLogo={props.hideProviderLogo}
								providerModel={providerModel}
								isProviderCatalog={true}
								pageName={props.pageName}
							/>
						</ProviderConnectHOC>
					);
				}
			});
			if (blocks.length > 3) {
				blocks.splice(3, 0, adElem);
			} else {
				blocks.push(adElem);
			}
			return blocks;
		} else {
			let blocks = [];
			let lastWasElite = false;
			let itemsInBlock = [];
			let blocksCounter = 0;
			let adBlockWasAdded = props.withoutAdBlock;
			let adBlockPlace = 3;
			for (var i = 0; i < items.length; i++) {
				let item = items[i];
				if (
					!!parseInt(item.vip_provider) === lastWasElite &&
					(adBlockWasAdded || i != adBlockPlace)
				) {
					if (!item?.sell_self?.provider?.name) {
						itemsInBlock.push(
							<ProviderConnectHOC key={i} callbackFn={() => props.onProviderConnect(item)}>
								<ProviderUpdatedItemContainer
									text={text}
									onProviderSelect={() => props.onProviderSelect(item)}
									onProviderRates={() => props.onProviderRates(item)}
									onProviderReviews={() => props.onProviderReviews(item)}
									data={item}
									windowSize={windowSize}
									flat={props.flat && !windowSize.xs}
									ratesView={props.ratesView}
									tariffs={tariffs}
									hideProviderLogo={props.hideProviderLogo}
									providerModel={providerModel}
									viewCountTariff={true}
									isProviderCatalog={true}
									pageName={props.pageName}
								/>
							</ProviderConnectHOC>
						);
					} else {
						itemsInBlock.push(
							<ProviderConnectHOC key={i} callbackFn={() => props.onProviderConnect(item)}>
								<ProviderUpdatedItemContainer
									selled={true}
									text={text}
									onProviderSelect={() => props.onProviderSelect(item)}
									onProviderRates={() => props.onProviderRates(item)}
									data={item}
									windowSize={windowSize}
									flat={props.flat && !windowSize.xs}
									ratesView={props.ratesView}
									tariffs={tariffs}
									hideProviderLogo={props.hideProviderLogo}
									providerModel={providerModel}
									viewCountTariff={true}
									isProviderCatalog={true}
									pageName={props.pageName}
								/>
							</ProviderConnectHOC>
						);
					}
				} else {
					if (itemsInBlock.length > 0) {
						blocks.push(
							<div key={blocksCounter} className={classes.blocksWrapper}>
								{itemsInBlock}
							</div>
						);
					}
					if (!adBlockWasAdded && i == adBlockPlace && !props.withoutAdBlock) {
						blocks.push(<OneClick key="adblock2" />);
						adBlockWasAdded = true;
					}
					itemsInBlock = [];
					blocksCounter++;
					i--;
					lastWasElite = !lastWasElite;
				}
				if (i == items.length - 1) {
					if (itemsInBlock.length > 0) {
						blocks.push(
							<div key={blocksCounter} className={classes.blocksWrapper}>
								{itemsInBlock}
							</div>
						);
					}
				}
			}
			if (!adBlockWasAdded && !props.withoutAdBlock) {
				blocks.push(<OneClick key="adblock2" />);
				adBlockWasAdded = true;
			}
			return <MicroMarkupTariffsLayout tariffs={tariffs}>{blocks}</MicroMarkupTariffsLayout>;
		}
	};

	let {
		text,
		match: { params },
	} = props;

	const toHomeURL = generateUrl(Routes.OrderToHome.route, {
		regionUrl: params.regionUrl,
	});
	let siteCode = props.ApplicationModel.siteCode;
	let phoneNumber =
		(isMainSiteCode(siteCode) && "+7 800 302-32-76") ||
		(isPiterSiteCode(siteCode) && "+7 (812) 385-66-34") ||
		(isMoscowSiteCode(siteCode) && "+7 (495) 256-00-21");

	function displayText() {
		return (
			<div>
				{text.NO_TARIFFS_WITH_FILTER}
				<span style={{ whiteSpace: "nowrap" }}>{phoneNumber}</span> {text.NO_TARIFFS_WITH_FILTER_2}
			</div>
		);
	}
	let windowSize = props.ApplicationModel.windowSizeModel.windowSizes;
	useEffect(() => {
		sendYandexMetrika();
	}, []);
	useEffect(() => {
		if (
			windowSize.height &&
			connectTariffButton === "connect" &&
			!!tariffs?.length &&
			tariffs.find((tariff) => tariff?.provider?.vip_provider == 1) &&
			tariffs.find(
				(tariff) => tariff?.provider?.provider_settings?.tariffs?.value === "button_text"
			)
		) {
			sendMetriks("OPEN_NEW_TEXT");
		}
	}, [tariffs, windowSize]);
	if (!props.items.length) {
		return (
			<Container>
				<Row>
					<Col
						lg={{ size: 4, offset: 4 }}
						md={{ size: 4, offset: 4 }}
						sm={{ size: 4, offset: 4 }}
						xs={{ size: 6, offset: 3 }}
					>
						<EmptyStub
							header={text.NO_PROVIDERS_HEADER}
							text={displayText()}
							icon={
								<span
									className="icon48 icon-balance"
									style={{
										fontSize: "48px",
										color: "#5812fe",
									}}
								/>
							}
							button={
								<Button
									component={<Link to={toHomeURL} />}
									typeText={"small"}
									size={"low"}
									status={"purple"}
								>
									<span
										className="icon48 icon-playlist-add"
										style={{
											fontSize: "24px",
											color: "#d3cee1",
										}}
									/>
									{text.upperMenuFindInternet}
								</Button>
							}
						/>
					</Col>
				</Row>
			</Container>
		);
	}
	return (
		<div className={classes.root}>
			<Container>
				<Row>
					<Col xs={12}>
						<div
							className={classNames(classes.wrapper, {
								[classes.noFlatWrapper]: !props.flat,
							})}
						>
							{generateProviders()}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

ListOfProvidersWithInjectedTariffs.efaultProps = {
	onProviderSelect: () => {},
	onProviderConnect: () => {},
	onProviderReviews: () => {},
	onProviderRates: () => {},
	sendMetrica: () => {},
	withoutAdBlock: false,
};

export default pipe(
	observer,
	inject("ApplicationModel"),
	withDefaultParams,
	withRouter
)(ListOfProvidersWithInjectedTariffs);
